import { createContext, useContext, useMemo, type ReactNode } from 'react';
import type { Permission } from '@maestro/shared/permissions';
import { renderablePermissions } from './console-admin';

// Resolved once by the provider rather than awaited per control: an async check would
// paint the permitted version first and then retract it.
const PermissionContext = createContext<readonly Permission[]>([]);

export function PermissionProvider({
  role,
  children,
}: {
  role: string | undefined;
  children: ReactNode;
}) {
  const permissions = useMemo(() => renderablePermissions(role), [role]);
  return <PermissionContext.Provider value={permissions}>{children}</PermissionContext.Provider>;
}

export function useHasPermission(permission: Permission): boolean {
  return useContext(PermissionContext).includes(permission);
}
